import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import { useLocalizedHref } from "@/libraries/web-framework";

import { CtaButton } from "./components";

export type closingBannerProps = {
    readonly text: string;
    readonly imgUrl: string;
    readonly altText: string;
    readonly buttonText: string;
    readonly ctaButtonUrl: string;
    readonly starImageUrl: string;
    readonly starsAltText: string;
};

const ctaBannerContainer = css({
    width: "100%",
    position: "relative",
    display: "grid",
    gridTemplateColumns: "2fr 1fr",
    justifyItems: "center",
    alignItems: "center",
    gap: "0",
    [":before"]: {
        content: "",
        background: "#1868DB",
        position: "absolute",
        width: "100%",
        height: "100%",
        zIndex: "-1"
    },
    [media.only.md]: {
        padding: "0 10%",
        height: "452px"
    },
    [media.only.sm]: {
        padding: "0 10%",
        height: "452px"
    },
    [media.below.sm]: {
        padding: "45px 10% 10px",
        height: "630px",
        gridTemplateColumns: "1fr",
        gap: "32px",
        [":before"]: {
            height: "100%"
        }
    }
});

const contentContainer = css({
    maxWidth: "765px",
    fontFamily: "var(--bxp-charlie-display-font-family)",
    fontWeight: "700",
    fontSize: "40px",
    lineHeight: "48px",
    color: "#ffffff",
    boxSizing: "border-box",
    padding: "0 20px",
    justifySelf: "end",
    [media.below.sm]: {
        fontSize: "30px",
        lineHeight: "36px",
        textAlign: "center"
    }
});

const headerStyles = css({
    marginBlockEnd: "24px"
});

const imageContainer = css({
    alignSelf: "end",
    width: "303px",
    height: "302px",
    position: "relative",
    justifySelf: "start",
    ["> img"]: {
        width: "100%",
        height: "auto",
        zIndex: "-1",
        position: "relative",
        insetBlockStart: "3px"
    },
    [media.only.lg]: {
        insetBlockStart: "5px"
    },

    [media.only.md]: {
        position: "relative",
        alignSelf: "end",
        insetBlockStart: "27px",
        justifySelf: "center"
    },
    [media.only.sm]: {
        position: "relative",
        alignSelf: "end",
        insetBlockStart: "27px",
        justifySelf: "center"
    },
    [media.below.sm]: {
        position: "relative",
        alignSelf: "end",
        justifySelf: "center",
        insetBlockEnd: "-18px"
    }
});

const overlayStarImage = css({
    position: "absolute",
    insetBlockStart: "11px",
    insetInlineStart: "60px"
});

export const ClosingBanner = ({
    text,
    imgUrl,
    altText,
    starImageUrl,
    starsAltText,
    buttonText,
    ctaButtonUrl
}: closingBannerProps) => {
    return (
        <div css={ctaBannerContainer}>
            <div css={contentContainer}>
                <div css={headerStyles}>{text}</div>
                <CtaButton
                    analyticsEventLabel="atlas-55799-closing-cta-button-clicked"
                    text={buttonText}
                    ctaButtonUrl={useLocalizedHref(ctaButtonUrl)}
                    bgColor="#FFC400"
                    textColor="#000000"
                />
            </div>
            <div css={imageContainer}>
                <img src={useLocalizedHref(imgUrl)} alt={altText} />
                <div css={overlayStarImage}>
                    <img src={starImageUrl} alt={starsAltText} />
                </div>
            </div>
        </div>
    );
};
ClosingBanner.displayName = "ClosingBanner";
